import { ApiState } from "../../common/constants/api-constants";

export declare interface LoadPaypalSdkRequest {
  clientToken: string;
  userAutoLogin: boolean;
  'enable-funding': string;
  currencyCode: string;
  intent: "capture" | "authorize";
}

export declare interface DataCollectorRequest {
  clientToken: string;
}

export declare interface BraintreeState {
  braintreeClient: ApiState;
  dataCollector: ApiState;
  paypalCheckoutInstance: ApiState;
  loadPaypalSdk: ApiState;
  venmoInstance: ApiState;
  applePayInstance: ApiState;
  googlePayInstance: ApiState;
  googlePaymentClient: ApiState;
  isCreditCardFormLoaded: boolean;
  localPaymentInstance: ApiState;
}

export enum CREDIT_CARD_FIELDS {
  cardholderName = "cardholderName",
  number = "number",
  cvv = "cvv",
  expirationDate = "expirationDate",
}

export interface LocalPaymentRequest {
  clientToken: string;
  merchantAccountId?: string;
  redirectUrl?: string;
}
